export default __webpack_public_path__ + "static/webRotator/svg/e66d2051b31e898db21847da2ac41711.svg";